<button mat-button data-test="cancel" class="answer__cancel" color="primary" (click)="setAnswer()">
    {{label | keyReplace: replacers}}
</button>